






























import { FolderHistory } from "@/domain/history";
import { ShareDateTranslator } from "@/infrastructure/folder/translators";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class FolderHistoryTableView extends Mixins() {
  @Prop()
  histories: FolderHistory[];

  toFolderStatus(history: FolderHistory): string {
    return history.isDeleted
      ? "削除済み"
      : history.published
        ? "公開中"
        : "非公開";
  }

  toDateString(date: Date): string {
    const dateTranslator = new ShareDateTranslator();
    return dateTranslator.toDateTimeDispString(date);
  }

  sortFolderStatus(a: FolderHistory, b: FolderHistory): number {
    return (a.isDeleted ? 2 : a.published ? 0 : 1) - (b.isDeleted ? 2 : b.published ? 0 : 1);
  }
}
